export enum HomeContentId {
    HERO = "home_hero_page",
    SUBSCRIPTION = "home_subscription_page"
}

export const HomeContentScrollClass = "home-scroll-item";
export const HomeContentScrollContainer = "home-scroll-container";
